var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRaport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    transform: "translate(.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.99,
    cy: 35,
    r: 35,
    fill: "#FFDCE3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    d: "M27.367 52.473L45.86 71.048a29.282 29.282 0 0 0 4.586-2.785L33.123 50.87a2 2 0 1 1 2.834-2.822l17.43 17.5c.038.037.073.076.107.116a29.302 29.302 0 0 0 3.4-3.976L46.123 50.87a2 2 0 1 1 2.835-2.822l10.079 10.123a29.187 29.187 0 0 0 2.982-9.443 2 2 0 1 1 3.963.542c-2.14 15.622-14.913 27.464-30.401 28.634a2.01 2.01 0 0 1-.986.06c-.528.024-1.059.036-1.593.035a32.83 32.83 0 0 1-22.713-9.094 2.005 2.005 0 0 1-.301-.364 2 2 0 0 1-.373-3.053l18.61-19.76a2 2 0 0 1 2.911 2.742l-3.769 4.002zm-2.744 2.913l-3.618 3.842c.136.083.265.183.382.3l14.297 14.354a29.126 29.126 0 0 0 6.135-1.223L24.623 55.386zm-6.3 6.69l-4.433 4.707a28.831 28.831 0 0 0 16.113 7.064L18.553 62.35a2.012 2.012 0 0 1-.23-.275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    d: "M7.895 59.511a2 2 0 0 1-3.43 2.058 33.65 33.65 0 0 1-4.444-12.46 2 2 0 1 1 3.958-.577A29.65 29.65 0 0 0 7.895 59.51zM38.97 39h22.533a30.59 30.59 0 0 0-1.067-3.519A29.071 29.071 0 0 0 38.97 16.373V39zm26.926 1.606a2 2 0 0 1-1.368 2.22c-.25.112-.526.174-.818.174H36.97a2 2 0 0 1-2-2V14a2 2 0 0 1 2.262-1.983c12.488 1.65 22.954 10.25 26.974 22.13a34 34 0 0 1 1.69 6.46zM27 44.794l.231-28.483C15.071 18.736 5.67 28.627 3.982 41.059a2 2 0 1 1-3.964-.538C2.04 25.625 13.805 13.939 28.715 12.016A2 2 0 0 1 28.97 12h.28a2 2 0 0 1 2 2.016L31 44.826c-.01 1.167.91 2.13 2 2.174h31a2 2 0 1 1 0 4l-31.077-.001A6.16 6.16 0 0 1 27 44.794z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRaport);
export default __webpack_public_path__ + "static/media/ic-raport.cd1b7b5c44b69e0a897e2f00f24c3805.svg";
export { ForwardRef as ReactComponent };